export const emptyGuid = '00000000-0000-0000-0000-000000000000';

export function newGuid() {
    try {
        return crypto.randomUUID();
    }
    catch {
        // UUIDs using Math.random is strongly discouraged
        // however crypto.randomUUID() is only available in localhost and over https
        // putting this here as backup method
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}